import { gql } from "@apollo/client";

export const CREATE_USER = gql`
  mutation createUser($data: CreateUserInput!) {
    createUser(data: $data) {
      id
      name
      phone
      uid
      push_token
      token
      token_expires_at
      is_root
      is_callcenter
      passenger_id
      acting_region_id
      franchise {
        id
        name
        banner_path
        logo_path
      }
      actingRegion {
        id
        name
      }
    }
  }
`;

export const UPDATE_USER = gql`
  mutation updateUser($data: UpdateUserInput!) {
    updateUser(data: $data) {
      id
      name
      phone
      uid
      push_token
      is_root
      franchise {
        id
        name
      }
      actingRegion {
        id
        name
      }
    }
  }
`;
export default CREATE_USER;
